import { put } from "redux-saga/effects";
import { ApiCaller, Utils } from "../../config";
import { LiveAction } from "../actions";

export default class LiveMiddleware {
  static *getLiveStreaming({ payload, cb }) {
    console.log(payload, "sssssssssssssss");

    try {
      const { limit = 10, offset = 0, keyword = "", status = "" } = payload;

      // Build query params safely — omit `type` when not provided to avoid
      // sending the literal string "undefined" which the API rejects.
      const statusParam =
        payload?.liveType || ""
          ? `status=${encodeURIComponent(payload.liveType)}`
          : "";
      const searchParam =
        payload?.search || ""
          ? `search=${encodeURIComponent(payload.search)}`
          : "";
      const pageParam = payload?.page
        ? `page=${encodeURIComponent(payload.page)}`
        : "";
      const typeParam = payload?.streamTypeSearch
        ? `type=${encodeURIComponent(payload.streamTypeSearch)}`
        : "";

      const query = [statusParam, searchParam, pageParam, typeParam]
        .filter(Boolean)
        .join("&");

      let res = yield ApiCaller.Get(`/events?${query}`);
      console.log(res, "liveeee");
      if (res.status == 200) {
        yield put(LiveAction.getLiveStreamingSuccess(res.data));

        if (cb) {
          cb();
        }
      } else {
        yield put(LiveAction.getLiveStreamingFailure(res.data.message));
        Utils.showSnackBar({
          message: res.data.message,
          severity: "error",
        });
      }
    } catch (err) {
      yield put(LiveAction.getLiveStreamingFailure());
      //   Utils.showSnackBar({
      //     message: "Reset password failed",
      //     severity: "error",
      //   });
    }
  }

  static *deleteEvent({ payload, cb }) {
    try {
      const { id } = payload;
      const res = yield ApiCaller.Delete(`/event/${id}`);

      if (res.status === 200) {
        yield put(LiveAction.deleteEventSuccess(id));
        Utils.showSnackBar({
          message: "Event deleted successfully",
          severity: "success",
        });
        if (cb) cb();
      } else {
        yield put(LiveAction.deleteEventFailure(res.data.message));
        Utils.showSnackBar({ message: res.data.message, severity: "error" });
      }
    } catch (err) {
      yield put(LiveAction.deleteEventFailure(err.message));
      Utils.showSnackBar({ message: err.message, severity: "error" });
    }
  }

  static *endEvent({ payload }) {
    try {
      const { id, cb } = payload;
      const res = yield ApiCaller.Patch(`/event/${id}/end`, {
        total_viewers: 0,
      });

      // Treat 200, 201, and 204 as success responses from the API
      if (
        res &&
        (res.status === 200 || res.status === 201 || res.status === 204)
      ) {
        if (cb) cb();
        yield put(LiveAction.endEventSuccess(id));

        // Prefer server message when available
        const successMessage =
          (res.data && res.data.message) || "Event ended successfully";

        Utils.showSnackBar({
          message: successMessage,
          severity: "success",
        });
      } else {
        const errMsg =
          (res && res.data && res.data.message) ||
          (res && res.message) ||
          "Failed to end event";
        yield put(LiveAction.endEventFailure(errMsg));
        Utils.showSnackBar({
          message: errMsg,
          severity: "error",
        });
      }
    } catch (err) {
      yield put(LiveAction.endEventFailure(err.message));
      Utils.showSnackBar({
        message: err.message,
        severity: "error",
      });
    }
  }

  static *sendEventNotification({ payload, cb }) {
    console.log("event_ID_middleware", payload);
    try {
      const res = yield ApiCaller.Post("/event/send/notification", payload);

      if (res && (res.status === 200 || res.status === 201)) {
        yield put(LiveAction.sendEventNotificationSuccess(res.data));

        Utils.showSnackBar({
          message: res.data?.message || "Notification sent successfully",
          severity: "success",
        });

        if (cb) cb();
      } else {
        const errMsg = res?.data?.message || "Failed to send notification";

        yield put(LiveAction.sendEventNotificationFailure(errMsg));

        Utils.showSnackBar({
          message: errMsg,
          severity: "error",
        });
      }
    } catch (err) {
      yield put(LiveAction.sendEventNotificationFailure(err.message));
      Utils.showSnackBar({
        message: err.message,
        severity: "error",
      });
    }
  }

  static *sendEventEmail({ payload, cb }) {
    try {
      const formData = new FormData();
      // payload: { message, attachments: [], status }
      formData.append("message", payload.message);

      if (payload.status) {
        formData.append("status", payload.status);
      }

      if (payload.attachments && payload.attachments.length > 0) {
        payload.attachments.forEach((file) => {
          formData.append("attachments", file);
        });
      }

      const res = yield ApiCaller.Post("/event/send/emails", formData);

      if (res && (res.status === 200 || res.status === 201)) {
        yield put(LiveAction.sendEventEmailSuccess(res.data));

        Utils.showSnackBar({
          message: res.data?.message || "Emails sent successfully",
          severity: "success",
        });

        if (cb) cb();
      } else {
        const errMsg = res?.data?.message || "Failed to send emails";

        yield put(LiveAction.sendEventEmailFailure(errMsg));

        Utils.showSnackBar({
          message: errMsg,
          severity: "error",
        });
      }
    } catch (err) {
      yield put(LiveAction.sendEventEmailFailure(err.message));
      Utils.showSnackBar({
        message: err.message,
        severity: "error",
      });
    }
  }
}
